import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input} from '@angular/core';
import {ControlContainer} from '@angular/forms';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {IValueText } from 'src/app/shared/shared-module';
import {BaseInifiteAutocomplete } from '../base-inifite-autocomplete.component';
import { AuthenticationService } from 'src/core/http/authentication.service';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-multi-tags',
  templateUrl: './multi-tags.component.html',
  styleUrls: ['./multi-tags.component.scss']
})
export class MultiTagsComponent extends BaseInifiteAutocomplete  implements OnInit, AfterViewInit {
  selectableYN = false;
  removableYN = true;
  addOnBlurYN = false;
  chipListDisabledYN = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];

  @Input() readOnly: boolean = false;
  @ViewChild('chipList') chipList: ElementRef<HTMLInputElement>;


  constructor(
    public controlContainer: ControlContainer,
    protected authenticationService: AuthenticationService
    ) {
    super(controlContainer, authenticationService);
  }


  ngOnInit() {
    if (!this.initSelection || !(this.initSelection instanceof Array)) {
      this.formControls.selection.setValue([]);
    } else {
      // Create a new array reference, in order not to modify the original one if user add/delete chips but then cancel editing.
      this.formControls.selection.setValue([...(this.initSelection)]);
    }

    this.monitorInputValueChanges();
  }


  ngAfterViewInit() {
    setTimeout(() => {
      if (this.formControls.selection.value === null || this.formControls.selection.value.length === 0) {
        if (this.openPanelIfNoValueOnInit) {
          this.inputRef.nativeElement.focus();
          this.autocompleteTrigger.openPanel();
        }
      }
    });

    if (!this.readOnly) {
      this.autocompleteTrigger.panelClosingActions
      .pipe(
        takeUntil(this.unsubscribe),
      )
      .subscribe(x => {
        if (this.autocompleteTrigger.activeOption) {
          const value = this.autocompleteTrigger.activeOption.value;
          this.selectItem(value);
        } else {
          // No item highlighted, so we check if in the list of items there is only one, if yes, we select it
          if (this.filteredItems.length === 1) {
            this.selectItem(this.filteredItems[0]);
          }
        }
      });
    }
  }


  setEnable(enbleYN: boolean) {
    if (enbleYN) {
        this.formControls.inputControl.enable();
        this.chipListDisabledYN = false;
    } else {
        this.formControls.inputControl.disable();
        this.chipListDisabledYN = true;
    }
}


  add(event: MatChipInputEvent): void {
    // // Add item only when MatAutocomplete is not open
    // // To make sure this does not conflict with OptionSelected Event
    // if (!this.autocompleteRef.isOpen) {
    //   const input = event.input;
    //   const value = event.value;

    //   // Add our item
    //   if ((value || '').trim()) {
    //     this.items.push(value.trim());
    //   }

    //   // Reset the input value
    //   if (input) {
    //     input.value = '';
    //   }

    //   this.itemCtrl.setValue(null);
    // }
  }


  remove(item: IValueText): void {
    const selectedItems = this.formControls.selection.value;
    const index = selectedItems.indexOf(item);

    if (index >= 0) {
      selectedItems.splice(index, 1);
      this.formControls.selection.setValue(selectedItems);
      this.formControls.selection.updateValueAndValidity();
      // this.formControls.selection.markAsDirty();
    }
  }


  selected(event: MatAutocompleteSelectedEvent): void {
    // console.log('Item Selected!', event);
    this.selectItem(event.option.value);
  }


  private selectItem(itemToSelect) {
    // this.formControls.selection.setErrors(null);
    const selectedItems = this.formControls.selection.value;
    const searchList = selectedItems.filter(item => this.internalDisplayItemFn(item) === this.internalDisplayItemFn(itemToSelect));
    const isDuplicate = searchList && searchList.length > 0; // this.selectedItems.indexOf(event.option.value) > 0;
    if (!isDuplicate) {
      selectedItems.push(itemToSelect);
    }

    // Trick: When selected() is invoked, the input value is changed, that will result to an api call to bind data to the drop down panel to be done whereas the user did not change his search text in the input.
    // So in order to prevent this useless api call, we set the value of the 'inputControl' control to the native text in the input
    this.inputRef.nativeElement.value = null;
    this.formControls.inputControl.setValue(this.inputRef.nativeElement.value); // , { onlySelf: true }  {emitEvent: false}
    // this.formControls.inputControl.setValue('', {emitEvent: true});
    // this.formControls.inputControl.updateValueAndValidity();
    // console.log(this.inputRef.nativeElement.value);

    this.formControls.selection.setValue(selectedItems);
    this.formControls.selection.updateValueAndValidity();
    // this.formControls.selection.markAsDirty();
    // setTimeout(() => {
    //   this.autocompleteTrigger.openPanel();
    // });
  }


  inputTextClicked() {
    if (!this.readOnly && !this.autocompleteTrigger.panelOpen) {
      this.autocompleteTrigger.openPanel();
    }
  }


  // https://stackoverflow.com/questions/48403154/orderby-with-ngfor-array
  // Sort a list by a specific property name
  sortListBy(list: any[], prop: string) {
    return list.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  }


}
